export default __webpack_public_path__ + "static/media/Icon4.75db45bf.svg";